import { PageAdminViews } from './PageAdminViews';

export function PageAdmin() {
  return <PageAdminViews />;
}
